module.exports = __webpack_public_path__ + "r-v3/img/ml_25_00_over.33bd0bbf.jpg";